export default {
  // Page title and subtitle
  title: 'My Pets',
  subtitle: 'You have {{count}} pets',
  
  // Loading and error states
  checkingAuth: 'Verifying identity...',
  loadingPets: 'Loading your pet data...',
  fetchErrorTitle: 'Unable to load pet data',
  retry: 'Retry',
  
  // Empty state
  noPetsTitle: 'No pets yet',
  noPetsSubtitle: 'Start building your first pet profile',
  addFirstPet: 'Add first pet',
  
  // Action buttons
  addPet: 'Add Pet',
  edit: 'Edit',
  delete: 'Delete',
  share: 'Share',
  shareNow: 'Share Now',
  preview: 'Preview',
  viewFullDetails: 'View Full Details',
  
  // View modes
  gridView: 'Grid View',
  listView: 'List View',
  
  // Statistics
  statistics: 'Statistics',
  totalPets: 'Total Pets',
  registeredPets: 'Registered',
  averageAge: 'Average Age',
  allPets: 'All Pets',
  weeklyAdded: 'Added This Week',
  recentlyAdded: 'Recently Added',
  mostCommonType: 'Most Common Type',
  
  // Search and filter
  searchPlaceholder: 'Search pet names, breeds, or types...',
  sortByName: 'Sort by Name',
  sortByCreated: 'Sort by Created Date',
  sortByType: 'Sort by Type',
  showingResults: 'Showing {{current}} / {{total}} pets',
  noMatchingPets: 'No matching pets',
  searchKeyword: 'Search keyword: {{keyword}}',
  typeFilter: 'Type filter: {{type}}',
  clearFilters: 'Clear Filters',
  
  // Pet information
  unnamedPet: 'Unnamed Pet',
  unknownBreed: 'Unknown Breed',
  yearsOld: 'years old',
  nextFeeding: 'Next Feeding',
  nextMedication: 'Next Medication',
  nextVetVisit: 'Next Vet Visit',
  location: 'Location',
  home: 'Home',
  notSet: 'Not Set',
  
  // Delete confirmation
  deleteError: 'Delete failed, please try again',
  deleteSuccess: 'Pet successfully deleted'
};